<template>
  <div class="g-content user-main">
    <div class="g-content-filter g-content-filter-title user-detail">
      <div class="g-content-filter-main common-user-detail">
        <h3>{{ $t('com_sider_menu_user_detail') }}</h3>

        <a-button type="primary" @click="() => this.$router.go(-1)" icon="double-left">
          {{ $t('com_btn_back') }}
        </a-button>
      </div>
    </div>
    <div class="g-content-main common-filter-main">
      <div class="user-form">
        <a-form-model
          ref="formElement"
          :label-col="{ span: 7 }"
          :wrapper-col="{ span: 14 }"
          v-if="userInfo"
        >
          <!-- 用户名 -->
          <a-form-model-item :label="$t('user_table_userName')">
            <div>
              <b>{{ userInfo.name }}</b>
            </div>
          </a-form-model-item>

          <!-- 昵称 -->
          <a-form-model-item :label="$t('user_table_nickName')">
            <div>{{ userInfo.nickName || '--' }}</div>
          </a-form-model-item>

          <!-- Owner -->
          <a-form-model-item :label="$t('user_table_belonged_customer')">
            <div v-if="customerInfo">
              <!-- 编辑 -->
              <router-link
                :to="`/manage/system/customer/detail/${customerInfo.customerId}`"
                v-if="
                  (authList.includes('auth_customer') &&
                    authList.includes('auth_customer_list') &&
                    authList.includes('auth_customer_detail')) ||
                    isSuperAdmin
                "
              >
                {{ customerInfo.name }}
              </router-link>

              <span v-else>{{ customerInfo.name }}</span>
            </div>
            <div v-else>
              --
            </div>
          </a-form-model-item>

          <!-- 平台用户 -->
          <a-form-model-item :label="$t('customer_table_platform')">
            <div>
              <span v-if="userInfo.root" style="color:#f00">
                {{ $t('com_table_yes') }}
              </span>
              <span v-else>{{ $t('com_table_no') }}</span>
            </div>
          </a-form-model-item>

          <!-- 禁用 -->
          <a-form-model-item :label="$t('com_form_disabled')">
            <div>
              <span v-if="userInfo.disable" style="color:#f00">
                {{ $t('com_table_yes') }}
              </span>
              <span v-else>{{ $t('com_table_no') }}</span>
            </div>
          </a-form-model-item>

          <!-- 角色 -->
          <a-form-model-item :label="$t('user_form_role')" v-if="currentRole">
            <div>
              <router-link
                :to="`/manage/system/role/list`"
                v-if="
                  (authList.includes('auth_role') && authList.includes('auth_role_list')) ||
                    isSuperAdmin
                "
              >
                {{ currentRole.name }}
              </router-link>
              <span v-else>{{ text }}</span>
            </div>
          </a-form-model-item>

          <!-- 最大可创建站点数 -->
          <a-form-model-item :label="$t('user_form_site_max')">
            <div style="color:#f00">{{ userInfo.allowCreateMaxStation }}</div>
          </a-form-model-item>

          <!-- 邮箱 -->
          <a-form-model-item :label="$t('user_table_email')">
            <div>{{ userInfo.email }}</div>
          </a-form-model-item>

          <!-- 联系方式 -->
          <a-form-model-item :label="$t('com_table_contact')">
            <div>{{ userInfo.contact }}</div>
          </a-form-model-item>

          <!-- 备注 -->
          <a-form-model-item :label="$t('com_form_description')">
            <div>{{ userInfo.desc }}</div>
          </a-form-model-item>

          <!-- 创建时间 -->
          <a-form-model-item
            :label="$t('com_table_created_time')"
            prop="createTime"
            v-if="createEvent"
          >
            <div>{{ createEvent.executeTime | formatDate }}</div>
          </a-form-model-item>

          <div style="text-align:center;margin:50px 0;">
            <router-link
              :to="{ name: 'UserUpdate', params: { id: userInfo.userId } }"
              v-auth="['auth_user_edit']"
            >
              <a-button type="primary" style="margin-right:15px">
                {{ $t('com_btn_edit') }}
              </a-button>
            </router-link>

            <router-link
              :to="{ name: 'UserAuth', params: { id: userInfo.userId } }"
              v-auth.and="['auth_user_authData', 'auth_user_customerStationList']"
            >
              <a-button type="default" style="margin-right:15px">
                {{ $t('com_btn_auth') }}
              </a-button>
            </router-link>
          </div>
        </a-form-model>
      </div>
    </div>
  </div>
</template>
<script>
import * as RoleAPI from '@/api/system/role';
import * as API from '@/api/system/user';
import Config from '@/config';
import cusomterMixin from '@/mixins/customer';
import { mapGetters } from 'vuex';

export default {
  mixins: [cusomterMixin],
  data() {
    return {
      Config,
      // 角色列表
      roleList: [],
      userInfo: null,
      createEvent: null,
      id: null,
      currentRole: null,
      customerInfo: null,
    };
  },
  created() {
    if (this.$route && this.$route.params && this.$route.params.id) {
      this.id = this.$route.params.id;
    }
    // 先获取form需要的数据
    this.getFormData();
  },
  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),
  },
  methods: {
    // 先获取表单数据
    getFormData() {
      const apiList = [
        // 获取所有角色
        this.getAllRoleList(),

        this.getUserInfo(),
      ];

      Promise.all(apiList).finally(() => {
        // 全部接口返回时，清除loading
        this.$store.commit('setPageLoading', false);

        this.getCurrentCustomer(this.userInfo.customerId);

        this.currentRole = this.roleList.find(item => item.id === this.userInfo.roleId);
      });
    },

    // 获取所有角色
    getAllRoleList() {
      return RoleAPI.RoleListAll().then(res => {
        if (res.code === 0) {
          this.roleList = res.data;
        }
      });
    },

    // 编辑时获取用户数据
    getUserInfo() {
      if (!this.id) {
        return;
      }

      return API.UserDetail({ userId: this.id }).then(res => {
        if (res.code === 0) {
          this.userInfo = res.data.userInfo;
          this.createEvent = res.data.createEvent;
          this.customerInfo = res.data.customerInfo;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.g-content.user-main {
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
}
::v-deep .g-content-filter-title {
  height: 84px !important;
}
::v-deep .user-form {
  max-width: 900px;
  width: 100%;
  height: 100%;
  .ant-form-item {
    margin: 0 0 5px 0;
  }
  .ant-form-item-label {
    label {
      color: #aaa;
    }
  }

  .ant-form-item-children {
    // font-size: 14px;
    img {
      max-width: 200px;
    }
  }
}
</style>
